import React, { useState, useEffect } from "react";
import { EditText, EditTextarea } from "react-edit-text";
import { useDispatch, useSelector } from "react-redux";
import { updateCorrectMcqAnswer, updateMcqAnswer, updateSelectedComponentType, removeQuestionIdFromOptions } from "../../../../redux/slices/userActivity";

import Correct from "../../../../assets/icons/correct.svg";
import CorrectGreen from "../../../../assets/icons/correctGreen.svg";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";

const maxAnswerChar = 40

export default function SingleAnswer({ style, answer, totalCorrectAnswers }) {

  const { selectedUserActivity, modalOpen } = useSelector((state) => state.userActivity);
  const { modalOpen: previewModalOpen, showAnswers, isMobile } = useSelector(state => state.preview);
  const [hover, setHover] = useState(false)
  const { width } = useWindowDimensions();
 
  const dispatch = useDispatch();

  const reset = ()=> {
    dispatch(
      updateMcqAnswer({
        selectedActivityIdx: selectedUserActivity,
        answer: 'answer',
        optionId: answer.id,
      })
    )
  }

  const handleChange = (e) => {
      dispatch(
        updateMcqAnswer({
          selectedActivityIdx: selectedUserActivity,
          answer: e.target.value,
          optionId: answer.id,
        })
      );
  };

  useEffect(() => {
    dispatch(
      removeQuestionIdFromOptions({
        selectedActivityIdx: selectedUserActivity,
      })
    );
  }, []);

  const handleClick = e => {
    e.stopPropagation();
    dispatch(
      updateSelectedComponentType({
        type: "text",
        name: "answer",
      })
    );
  };

  const handleButtonClick = e => {
    e.stopPropagation();
    dispatch(
      updateSelectedComponentType({
        type: "button",
        name: "answer",
        hoverName: 'answerHover'
      })
    );
  };

  const changeCorrect = () => {
    if (previewModalOpen) return
    if (totalCorrectAnswers === 1 && answer.is_correct === true) return
    dispatch(
      updateCorrectMcqAnswer({
        selectedActivityIdx: selectedUserActivity,
        optionId: answer.id,
        is_correct: !answer.is_correct,
      })
    );
  };

  let inputColor = '#000'
  let inputFontSize = '1rem'
  let inputTextDecoration = ''
  if (style.answer) {
    if (Object.keys(style.answer).includes('color')) inputColor = style.answer.color
    if (Object.keys(style.answer).includes('fontSize')) inputFontSize = style.answer.fontSize
    if (Object.keys(style.answer).includes('textDecoration')) inputTextDecoration = style.answer.textDecoration
  }
// console.log(style.answer);
  return (
    <div key={answer} className={`col-sm-12 ${isMobile && previewModalOpen && width > 1275 ? 'col-lg-12  col-md-12 ' : 'col-lg-6  col-md-6 '} `} style={style.answerBox}>
      {!modalOpen && (
        <div className="answer_icon_container" onClick={changeCorrect}>
          {
            answer.is_correct
              ?
              (previewModalOpen && !showAnswers ? <img src={Correct} /> : <img src={CorrectGreen} />)
              :
              <img src={Correct} />
          }
        </div>
      )}
      <div className="answer_box" style={{ ...style.answer, ...(hover ? style.answerHover : null) }} onClick={e => handleButtonClick(e)}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}>

        {/* {answer} */}
        <div onClick={e => handleClick(e)} style={{ display: 'inline-block', }} >
          <EditText onClick={e => handleClick(e)}
            value={answer.option}
            onBlur={() => {answer.option ==='' && reset() }}
            className="editable_text"
            style={{
              wordBreak: 'break-word', padding: '0 0.2rem',
              minWidth: '8px', backgroundColor: 'transparent',
              margin: 0,
              textAlign: 'center',
              color: inputColor,
              fontSize: inputFontSize,
              textDecoration: inputTextDecoration
            }}
            onChange={e => e.target.value.length > maxAnswerChar ? null : handleChange(e)}
            readonly={previewModalOpen ? true : false} />
        </div>
      </div>
    </div>
  );
}
